import React from 'react'
import { Modal } from 'components'


const OrderResult = ({ result }) => {
  let html = null;

  switch (result) {
    case 1:
    case 3:
      html = (
        <div className='state-success margin-top-10vh text-center'>
          <i className='colour-orange txt-5em elegant elegant-eleganticons-49'/>

          <h3>
            已新增，請至{(result === 1) ? '「自建圖表」' : '「達人策略」'}使用
          </h3>
        </div>
      );

      break;

    case 2:
      html = (
        <div className='state-fail margin-top-10vh text-center'>
          <i className='colour-orange txt-5em elegant elegant-eleganticons-48'/>

          <h3>請稍後再試，或聯絡工程師</h3>
        </div>
      );

      break;

    default:
  }

  return (
    <Modal
      id='add-single'
      customClassName='mobile-height'
      title={`新增${(result === 1) ? '套件' : '達人策略'}${(result === 2) ? '沒有' : ''}成功`}
      html={html}
      leaveTxt='我知道了'
    />
  );
}


export { OrderResult }
